import { render, staticRenderFns } from "./ViolationRejectForm.vue?vue&type=template&id=548cddfa&"
import script from "./ViolationRejectForm.vue?vue&type=script&lang=ts&"
export * from "./ViolationRejectForm.vue?vue&type=script&lang=ts&"
import style0 from "./ViolationRejectForm.vue?vue&type=style&index=0&id=548cddfa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports